import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Linkedin, Mail, Quote } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Teams = () => {
  const navigate = useNavigate();

  const leadership = [
    {
      name: "Sudharsan Ramesh",
      role: "Founder & Chief Executive Officer",
      image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/IMG_7716.PNG?alt=media&token=e3c49b9d-ae2b-42c2-9dc7-ad4f1300b187",
      bio: "Vision-driven entrepreneur with a strong technology background, focused on building scalable, consumer-first platforms that solve real-world problems.",
      quote: "We're not just building a service platform; we're creating a movement that empowers millions.",
      linkedin: "https://www.linkedin.com/in/sudharsan-ramesh-9a7300252/",
      email: "Sudharsan@doorush.in"
    },
    {
      name: "Praison Cherub",
      role: "Co-Founder & Chief Business Officer",
      image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/Praison.png?alt=media&token=fe3a708f-91cc-4f10-aa86-c5badf9554b1",
      bio: "Former physiotherapist turned tech enthusiast, bringing a strong user-centric mindset and deep interest in building impactful, technology-driven businesses.",
      quote: "We're not just building a service platform; we're creating a movement that empowers millions.",
      linkedin: "https://www.linkedin.com/in/praison-cherub-987285230/",
      email: "PraisonCherub@doorush.in"
    },
    {
      name: "Raghulan Gowthaman",
      role: "Co-Founder",
      image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/Raghulan_gowthaman.png?alt=media&token=ed82f0d9-7644-4612-b4d8-4d03bd335787",
      bio: "Business strategist with a strong execution mindset, combining operational experience and startup insight to help build and scale sustainable tech-led ventures.",
      quote: "Technology should make life simpler, not complicated. That's our north star.",
      linkedin: "https://www.linkedin.com/in/raghulang/",
      email: "raghulan@virtuacorp.com.au"
    }
  ];

  const executives = [
    {
      name: "Mohammed Yesrab",
      role: "Head of Partner Relations",
      image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/DSC05478.JPG?alt=media&token=4200b8bd-078d-4824-8fa3-4a3cfd7ceee0",
      bio: "People-first professional skilled in building strong partner relationships, driving trust, and creating win-win ecosystems at scale.",
      linkedin: "https://www.linkedin.com/in/mohammed-yesrab-92b122169/",
      email: "Mohammedyesrab@doorush.in"
    },
    {
      name: "Vishwa Rajendran",
      role: "Head of Marketing",
      image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/DSC05499.JPG?alt=media&token=7d8150ca-3ea3-4dca-bc62-aa6de89a946c",
      bio: "Growth-focused marketer with a strong brand sense, driving customer acquisition, retention, and market presence through data-led storytelling.",
      linkedin: "https://www.linkedin.com/in/vishwa-rajendran-82573b249/",
      email: "vishwarajendran@doorush.in"
    },
    // {
    //   name: "Prasanna Chandrasekar",
    //   role: "Head of Fiel Operations",
    //   image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/13c438aa-f2f4-42e6-9372-19a5704e62a3.JPG?alt=media&token=a200f992-5090-4e54-9024-a525c32d9af1",
    //   bio: "Operations leader with deep on-ground experience, ensuring seamless service execution, partner efficiency, and consistent quality at scale.",
    //   linkedin: "#",
    //   email: "PrasannaChandrasekar@doorush.in"
    // },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-gray-50 to-white dark:from-[#0a0a0a] dark:via-[#0f0f0f] dark:to-[#0a0a0a]">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 dark:bg-[#0a0a0a]/95 backdrop-blur-md shadow-md border-b border-gray-100 dark:border-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center space-x-2 cursor-pointer" onClick={() => navigate('/')}>
              <img 
                src="https://customer-assets.emergentagent.com/job_ec527428-3aec-42a4-a1f7-d2e66c0be0df/artifacts/hktez0bk_logo_transs.png" 
                alt="doorush logo" 
                className="h-10 w-auto"
              />
            </div>
            <Button onClick={() => navigate('/')} variant="outline" className="border-2 border-[#007e7a] text-[#007e7a] hover:bg-[#007e7a] hover:text-white transition-all duration-300">
              Back to Home
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-40 pb-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#007e7a]/5 via-transparent to-[#007e7a]/5"></div>
        <div className="absolute top-20 right-20 w-96 h-96 bg-[#007e7a]/10 dark:bg-[#00a89d]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#007e7a]/5 dark:bg-[#00a89d]/5 rounded-full blur-3xl"></div>
        
        <div className="max-w-5xl mx-auto text-center relative z-10">
          <Badge className="bg-[#007e7a]/10 text-[#007e7a] dark:text-[#00a89d] hover:bg-[#007e7a]/20 border-[#007e7a]/20 backdrop-blur-sm mb-8 px-6 py-2 text-base">
            Leadership Team
          </Badge>
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-gray-900 dark:text-white mb-8 tracking-tight leading-none">
            Meet the Minds<br />
            <span className="bg-gradient-to-r from-[#007e7a] to-[#00a89d] bg-clip-text text-transparent">Behind doorush</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 dark:text-gray-300 leading-relaxed max-w-3xl mx-auto">
            A world-class team of innovators, operators, and visionaries committed to transforming India's home services landscape.
          </p>
        </div>
      </section>

      {/* Leadership Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 dark:text-white mb-4 tracking-tight">Founders</h2>
            <p className="text-xl text-gray-600 dark:text-gray-300">Visionaries leading the doorush revolution</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            {leadership.map((member, index) => (
              <Card
  key={index}
  className="group relative bg-white dark:bg-[#141414]
             border border-gray-200/60 dark:border-gray-800/60
             rounded-3xl overflow-hidden
             transition-all duration-500
             hover:shadow-[0_30px_70px_-20px_rgba(0,126,122,0.35)]
             hover:-translate-y-1"
>
  <CardContent className="p-0">

    {/* IMAGE SECTION */}
    <div className="relative h-[420px] overflow-hidden">
      <img
        src={member.image}
        alt={member.name}
        className="w-full h-full object-cover
                   transition-transform duration-700
                   group-hover:scale-105"
      />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t
                      from-black/70 via-black/30 to-transparent" />

      {/* Name + Role */}
      <div className="absolute bottom-6 left-6 right-6">
        <h3 className="text-3xl font-bold text-white leading-tight">
          {member.name}
        </h3>
        <p className="mt-1 text-[#7fe6e0] font-semibold">
          {member.role}
        </p>
      </div>
    </div>

    {/* CONTENT */}
    <div className="p-8 text-center">
      <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
        {member.bio}
      </p>

      {/* QUOTE */}
      <div className="relative rounded-xl bg-gray-50 dark:bg-[#1c1c1c] p-5 mb-6 text-left">
        <Quote
          size={20}
          className="absolute -top-3 left-4 text-[#007e7a]/40"
        />
        <p className="text-sm italic text-gray-700 dark:text-gray-300">
          {member.quote}
        </p>
      </div>

      {/* ACTIONS */}
      <div className="flex gap-3">
        <a
          href={member.linkedin}
          className="flex-1 flex items-center justify-center gap-2
                     py-3 rounded-xl
                     bg-[#007e7a]/10 text-[#007e7a]
                     hover:bg-[#007e7a] hover:text-white
                     transition-all duration-300 text-sm font-semibold"
        >
          <Linkedin size={16} />
          LinkedIn
        </a>

        <a
          href={`mailto:${member.email}`}
          className="flex-1 flex items-center justify-center gap-2
                     py-3 rounded-xl
                     bg-gray-100 dark:bg-gray-800
                     hover:bg-gray-200 dark:hover:bg-gray-700
                     transition-all duration-300 text-sm font-semibold"
        >
          <Mail size={16} />
          Email
        </a>
      </div>
    </div>

  </CardContent>
</Card>
            ))}
          </div>
        </div>
      </section>

      {/* Executive Team */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50 dark:bg-[#0f0f0f]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 dark:text-white mb-4 tracking-tight">Executive Team</h2>
            <p className="text-xl text-gray-600 dark:text-gray-300">Leaders driving execution excellence</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {executives.map((member, index) => (
              <Card 
                key={index} 
                className="group relative bg-white dark:bg-[#1a1a1a] border border-gray-200 dark:border-gray-800 hover:border-[#007e7a]/20 dark:hover:border-[#00a89d]/20 rounded-2xl overflow-hidden transition-all duration-500 hover:shadow-xl hover:-translate-y-1"
              >
                <CardContent className="p-6">
                  <div className="flex flex-col items-center text-center">
                    <div className="relative mb-6">
                      <div className="w-32 h-32 rounded-full bg-gradient-to-br from-[#007e7a]/20 to-[#007e7a]/5 dark:from-[#00a89d]/20 dark:to-[#00a89d]/5 flex items-center justify-center">
                        <img 
                          src={member.image} 
                          alt={member.name}
                          className="w-28 h-28 rounded-full border-2 border-white dark:border-gray-800 shadow-lg group-hover:scale-110 transition-transform duration-500"
                        />
                      </div>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-1">{member.name}</h3>
                    <p className="text-[#007e7a] dark:text-[#00a89d] font-semibold mb-4">{member.role}</p>
                    <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-6">{member.bio}</p>
                    
                    <div className="flex gap-2 w-full">
                      <a 
                        href={member.linkedin} 
                        className="flex-1 flex items-center justify-center gap-2 py-2 bg-[#007e7a]/10 dark:bg-[#00a89d]/10 rounded-lg hover:bg-[#007e7a] dark:hover:bg-[#00a89d] text-[#007e7a] dark:text-[#00a89d] hover:text-white transition-all duration-300"
                      >
                        <Linkedin size={16} />
                      </a>
                      <a 
                        href={`mailto:${member.email}`}
                        className="flex-1 flex items-center justify-center gap-2 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-all duration-300"
                      >
                        <Mail size={16} />
                      </a>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#007e7a] via-[#006666] to-[#005555]"></div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
        </div>
        
        <div className="max-w-4xl mx-auto text-center relative z-10 text-white">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight">Join Our Mission</h2>
          <p className="text-xl md:text-2xl mb-10 opacity-90 leading-relaxed">
            We're building something extraordinary. Be part of the team that's transforming home services in India.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* <Button 
              size="lg"
              onClick={() => navigate('/careers')}
              className="bg-white text-[#007e7a] hover:bg-gray-100 text-lg px-10 py-7 rounded-full font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              View Open Positions
            </Button> */}
            <Button 
              size="lg"
              onClick={() => navigate('/contact')}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white/10 text-lg px-10 py-7 rounded-full font-semibold backdrop-blur-sm transition-all duration-300"
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Teams;
